import { styled } from '@mui/joy';

export const NormaliseCSSWrapper = styled('div')({
  '& a': { backgroundColor: 'transparent', textDecoration: 'none !important' },
  '& a:hover': { textDecoration: 'underline !important' },
  '& b, & strong': { fontWeight: 'bolder' },
  '& small': { fontSize: '80%' },
  '& sub, & sup': {
    fontSize: '75%',
    lineHeight: 0,
    position: 'relative',
    verticalAlign: 'baseline',
  },
  '& sub': { bottom: '-0.25em' },
  '& sup': { top: '-0.5em' },
  '& img': { borderStyle: 'none' },
  '& pre, & code, & kbd, & samp': { fontFamily: 'monospace, monospace', fontSize: '1em' },
  '& hr': { boxSizing: 'content-box', height: 0, overflow: 'visible' },
  '& details': { display: 'block' },
  '& summary': { display: 'list-item' },
  '& template, & [hidden]': { display: 'none' },
});

export const HTMLRenderer = styled(NormaliseCSSWrapper)<{ colorType?: 'primary' | 'secondary' }>(
  ({ theme, colorType = 'primary' }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
    color: theme.palette.text?.[colorType],
    a: {
      color: theme.vars.palette['hyperlink']['text'],
      textDecoration: 'none',
      textUnderlineOffset: '0.15em',
      '&:hover': { textDecoration: 'underline' },
    },
    '& > ul': {
      listStyleType: 'disc',
      marginLeft: '16px',
      '&  ul': {
        listStyleType: 'circle',
        marginLeft: '16px',
      },
      '& > ol': {
        listStyleType: 'decimal',
        marginLeft: '16px',
        '&  ol': {
          listStyleType: 'lower-alpha',
          marginLeft: '16px',
        },
      },
    },
    '& > ol': {
      listStyleType: 'decimal',
      marginLeft: '16px',
      '&  ol': {
        listStyleType: 'lower-alpha',
        marginLeft: '16px',
      },
      '& > ul': {
        listStyleType: 'disc',
        marginLeft: '16px',
        '&  ul': {
          listStyleType: 'circle',
          marginLeft: '16px',
        },
      },
    },
    'em, i': {
      fontStyle: 'italic',
    },
    u: {
      textDecoration: 'underline !important',
      textUnderlineOffset: '0.15em',
    },
    blockquote: {
      borderLeft: `4px solid ${theme.palette.divider}`,
      padding: theme.spacing(1),
      a: {
        color: theme.vars.palette['hyperlink']['text'],
        textDecoration: 'none',
        textUnderlineOffset: '0.15em',
        '&:hover': { textDecoration: 'underline' },
      },
    },
  })
);
